export const uploadOptions = {
  hookForm: { shouldValidate: true, shouldDirty: true, shouldTouch: true },
};
